import { Directive } from '@angular/core';

@Directive({
  selector: '[appFixedColumn]'
})
export class FixedColumnDirective {

  constructor() { }

}
